export default __webpack_public_path__ + "static/provider-clutch-8de99b7d7a39410019cba0986292e74c.jpg";